// i18n area 'hci' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.sv-SE.meta.json.
import type { enUS } from './hci'

export const svSE: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-kluster',
      createButton: 'Skapa Ceph-kluster',
      emptyTitle: 'Inget hanterat Ceph-kluster',
      emptyBody: 'TVirt distribuerar och äger Ceph på medlemsnoderna, hyperkonvergerat med VM-lasten. Skapa ett kluster: den första monitorn och dess manager föds automatiskt på den valda kontrollnoden — låt det sedan växa med fler monitorer och OSD-enheter.',
      pageTitle: 'Ceph-kluster',
      colState: 'Status',
      colMembers: 'Medlemmar',
      colSize: 'Storlek',
      colVersion: 'Ceph-version',
      sizeCell: '{used} GiB använda av {total} GiB totalt',
      phase: {
        'not-deployed': 'Inte deployat',
        deploying: 'Deploy pågår',
        healthy: 'Friskt',
        degraded: 'Degraderat',
        error: 'Fel',
        destroying: 'Förstörs',
        destroyed: 'Förstört'
      },
      health: {
        HEALTH_OK: 'Friskt (HEALTH_OK)',
        HEALTH_WARN: 'Med varningar (HEALTH_WARN)',
        HEALTH_ERR: 'I fel (HEALTH_ERR)',
        unknown: 'Ännu inte observerad',
        observedAt: 'observerad {time}'
      },
      create: {
        title: 'Skapa Ceph-kluster',
        info: 'När ett nytt Ceph-kluster skapas ska den första noden väljas — den där rollerna MON och MGR installeras. Dessutom ska du ange vilket subnät Ceph-trafiken ska gå över: public-subnätet används för den allmänna nätverkstrafiken, medan kluster-subnätet används för de interna replikorna mellan OSD:erna; det behöver inte nödvändigtvis vara olika subnät.',
        controlNode: 'Kontrollnod',
        controlNodeHint: 'Medlemsnoden där den första MON + MGR föds.',
        publicSubnet: 'Public-subnät',
        publicSubnetHint: 'Ett subnät registrerat i IPAM — Cephs public_network. Oföränderligt efter skapandet.',
        clusterSubnet: 'Kluster-subnät',
        clusterSubnetHint: 'Ett subnät registrerat i IPAM — Cephs cluster_network (replikering/backfill).',
        noSubnets: 'Inget registrerat subnät — skapa dem först i IPAM',
        sameSubnet: 'Samma subnät för public- och klustertrafiken',
        sameSubnetHint: 'Ikryssad = klusternätet (replikering/backfill) sammanfaller med public. Inte ikryssad = välj dess subnät OCH kontrollnodens adress inuti det.',
        controlAddress: 'Kontrollnodens adress',
        controlAddressHint: 'En adress som IPAM känner till för noden inom public-subnätet.',
        controlClusterAddress: 'Kontrollnodens klusteradress',
        controlClusterAddressHint: 'En adress som IPAM känner till för noden inom kluster-subnätet.',
        noAddresses: 'IPAM känner inte till några adresser för den här noden inom det valda subnätet',
        started: 'Klustret skapat — bootstrappen fortsätter som macrotask; fasen uppdaterar sig själv',
        error: 'Klustret avvisades'
      },
      detail: {
        actions: 'Tillgängliga åtgärder',
        tabOverview: 'Översikt',
        tabManagementNodes: 'MON & MGR',
        tabDisks: 'OSD',
        tabPools: 'Pooler',
        tabObjects: 'Objekt',
        tabCrush: 'CRUSH Map',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Avancerat',
        phase: 'Fas',
        checksTitle: 'Aktiva hälsocheckar',
        noChecks: 'Ingen aktiv hälsocheck',
        checkMuted: 'tystad',
        summaryPools: 'Pooler',
        summaryFilesystems: 'Filsystem',
        nodesCard: 'Noder',
        monHint: 'En MGR kör samplacerad med varje MON. Tre MON är det rekommenderade kvorumet; ett labbkluster börjar med en. OSD och MDS bor i sina egna flikar.',
        monHintSplit: 'MON och MGR är åtskilda på det här klustret (Avancerat): varje roll är ett eget medlemskap per nod. Tre MON är det rekommenderade kvorumet; minst en MGR måste finnas.',
        noMons: 'Ingen monitor deklarerad',
        addNode: 'Lägg till nod',
        removeNode: 'Ta bort nod',
        removeNodeFrom: 'Ta bort noden {node} (dess MON och den samplacerade MGR:en)',
        roleMon: 'Roll MON',
        roleMgr: 'Roll MGR',
        roleNa: 'N/A',
        roleNotObserved: 'ännu inte observerad',
        monInQuorum: 'i kvorum',
        monOutQuorum: 'utanför kvorum',
        mgrActive: 'aktiv',
        mgrStandby: 'standby',
        addRoleMon: 'Lägg till rollen MON',
        removeRoleMon: 'Ta bort rollen MON',
        addRoleMgr: 'Lägg till rollen MGR',
        removeRoleMgr: 'Ta bort rollen MGR',
        restartMon: 'Starta om MON-tjänsten',
        restartMgr: 'Starta om MGR-tjänsten',
        addMon: 'Lägg till MON',
        removeMon: 'Ta bort MON',
        removeMonFrom: 'Ta bort rollen MON från {node}',
        addMgr: 'Lägg till MGR',
        removeMgr: 'Ta bort MGR',
        removeMgrFrom: 'Ta bort rollen MGR från {node}',
        addMds: 'Lägg till MDS',
        removeMds: 'Ta bort MDS',
        removeMdsFrom: 'Ta bort rollen MDS från {node}',
        mdsSection: 'Metadata server (MDS)',
        noMds: 'Ingen MDS deklarerad — ett filsystem kräver först en',
        mdsHint: 'MDS-medlemskapet är sitt eget från dag ett: ett kluster utan CephFS deklarerar inga, en aktiv plus en standby tjänar ett filsystem väl. Ceph väljer aktiva och standby bland de deklarerade daemonerna.',
        mdsActiveFor: 'aktiv — {fs}',
        mdsNotObserved: 'ännu inte observerad',
        lastMdsGuard: 'Den sista MDS:en kan inte tas bort så länge ett filsystem finns — ta bort filsystemen först',
        lastMonGuard: 'Den sista MON:en kan inte tas bort — att förstöra klustret är enda utvägen',
        lastMgrGuard: 'Den sista MGR:en kan inte tas bort — ett hanterat kluster kör aldrig utan manager',
        registerDevice: 'Lägg till OSD',
        unregisterDevice: 'Avregistrera',
        activeDeviceGuard: 'Aktiv OSD — den lämnar via OSD-livscykeln, inte via registret',
        colNode: 'Nod',
        devicePhase: { registered: 'Registrerad', active: 'Aktiv' },
        health: 'Hälsa',
        state: 'Status',
        fsid: 'fsid',
        fsidPending: 'saknas — försök bootstrappen igen',
        version: 'Ceph-version',
        publicNetwork: 'Public-nät',
        clusterNetwork: 'Klusternät',
        clusterNetworkCollapsed: '= public',
        noActions: 'Ingen åtgärd tillgänglig i den här fasen',
        destroyedNote: 'Klustret förstört — raden tas bort automatiskt inom kort'
      },
      overview: {
        services: 'Tjänster',
        ok: 'friska',
        warning: 'warning',
        down: 'nere',
        pgTitle: 'PG-tillstånd',
        pgTotal: '{n} PG totalt',
        capacityTitle: 'Utrymme',
        ioTitle: 'Aktuell I/O',
        ioReadBw: 'Läsbandbredd',
        ioWriteBw: 'Skrivbandbredd',
        ioReadIops: 'Läs-IOPS',
        ioWriteIops: 'Skriv-IOPS',
        notObserved: 'ännu inte observerat'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Status',
        colSize: 'Storlek',
        colPgs: 'PG',
        empty: 'Ingen OSD — lägg till en från en deklarerad datadisk',
        markIn: 'Markera IN',
        markOut: 'Markera OUT',
        scrub: 'Utför scrub',
        deepScrub: 'Utför djup scrub',
        restart: 'Starta om tjänsten',
        details: 'Detaljer',
        actionGuard: 'Endast på en aktiv OSD i ett deployat kluster',
        inTitle: 'Markera OSD IN',
        inBody: 'osd.{id} går tillbaka in i datadistributionen (ceph osd in): Ceph balanserar om data till den.',
        outTitle: 'Markera OSD OUT',
        outBody: 'osd.{id} lämnar datadistributionen (ceph osd out): dess data balanseras om någon annanstans och redundansen är REDUCERAD medan backfillen kör. Reversibelt när som helst med Markera IN.',
        scrubTitle: 'Planera scrub',
        scrubBody: 'En scrub av osd.{id} planeras: MON:en köar den och PG-tillstånden i de följande sweeparna berättar utfallet.',
        deepScrubTitle: 'Planera djup scrub',
        deepScrubBody: 'En djup scrub av osd.{id} planeras: varianten som verifierar bytena — tyngre på I/O, samma mekanik.',
        restartTitle: 'Starta om OSD-tjänsten',
        restartBody: 'osd.{id} stoppas och startas om via workerns övervakning på sin nod.',
        started: 'Åtgärden startad — observationen uppdaterar sig själv',
        error: 'OSD-åtgärden avvisades'
      },
      osdDetail: {
        title: 'OSD-detaljer',
        tabGeneral: 'Allmänt',
        tabNetwork: 'Nätverk',
        tabDevices: 'Enheter',
        version: 'Version',
        hostname: 'Hostname',
        dataPath: 'OSD-datasökväg',
        objectStore: 'OSD object store',
        encrypted: 'Krypterad',
        yes: 'Ja',
        no: 'Nej',
        memory: 'Minnesanvändning (PSS)',
        pid: 'Process ID (PID)',
        front: 'Front-adress (klienter & monitorer)',
        hbFront: 'Heartbeat-adress front',
        back: 'Back-adress (OSD)',
        hbBack: 'Heartbeat-adress back',
        colDevice: 'Device',
        colType: 'Typ',
        colPhysical: 'Fysisk device',
        colSize: 'Storlek',
        volumeTitle: 'Volymdetaljer',
        creationTime: 'Skapad den',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Ingen device observerad för den här OSD:n'
      },
      restart: {
        title: 'Starta om tjänsten',
        monBody: 'MON-daemonen på {node} stoppas och startas om via workerns övervakning.',
        mgrBody: 'MGR-daemonen på {node} stoppas och startas om via workerns övervakning.',
        started: 'Omstarten startad — observationen uppdaterar sig själv',
        error: 'Omstarten avvisades'
      },
      encryptionMode: {
        alwaysOn: 'Alltid aktiverad (dmcrypt)',
        alwaysOff: 'Alltid inaktiverad',
        perOsd: 'Val per OSD',
        section: 'OSD-kryptering at rest',
        title: 'Byt OSD-krypteringsläge',
        hint: 'Hur NYA OSD:er prepareras. Befintliga OSD:er behåller sitt per-disk-tillstånd: för att ändra det tas OSD:n bort och skapas om.',
        body: 'Läget blir "{mode}" och gäller ENDAST NYA OSD:er: varje befintlig OSD behåller sitt nuvarande krypteringstillstånd.',
        apply: 'Byt läge',
        error: 'Lägesbytet avvisades'
      },
      pin: {
        address: 'Public-adress (valfri pin)',
        clusterAddress: 'Klusteradress (valfri pin)',
        autoPlaceholder: 'automatisk i subnätet {cidr}',
        hint: 'Adressering per daemon: tomt = Ceph hakar på själv inom det deklarerade nätet; ifyllt = den här instansen pinnas till adressen i sin conf-sektion.'
      },
      addMon: {
        title: 'Lägg till nod',
        node: 'Nod',
        address: 'Public-adress',
        addressHint: 'Nodens adresser som IPAM känner till inom public-subnätet — automatisk när en befintlig deklaration täcker noden.',
        clusterAddress: 'Klusteradress',
        clusterAddressHint: 'Obligatorisk: kluster-subnätet är separat och noden är ännu inte deklarerad där.',
        noAddresses: 'IPAM känner inte till några adresser för den här noden inom subnätet',
        error: 'Tillägget av MON:en avvisades'
      },
      removeMon: {
        title: 'Ta bort MON',
        body: 'MON:en och dess samplacerade MGR lämnar noden {node}. På ett deployat kluster stoppas daemonerna och tas bort ur kvorumet.',
        error: 'Borttagningen av MON:en avvisades'
      },
      addMgr: {
        title: 'Lägg till MGR',
        node: 'Nod',
        hint: 'Avancerat (åtskilda MON/MGR): en fristående manager föds på den valda medlemsnoden med en nod-affin task. Cephs active/standby-val utser själv den aktiva MGR:en.',
        error: 'Tillägget av MGR:en avvisades'
      },
      removeMgr: {
        title: 'Ta bort MGR',
        body: 'Den fristående MGR:en lämnar noden {node}. På ett deployat kluster stoppas daemonen och dess tillstånd tas bort; nodens MON (om den finns) rörs inte.',
        error: 'Borttagningen av MGR:en avvisades'
      },
      addMds: {
        title: 'Lägg till MDS',
        node: 'Nod',
        hint: 'CephFS metadata server: den föds på den valda medlemsnoden med en nod-affin task, övervakad av workern precis som MON och MGR. Ceph väljer själv aktiva och standby — en aktiv plus en standby tjänar ett filsystem väl.',
        error: 'Tillägget av MDS:en avvisades'
      },
      removeMds: {
        title: 'Ta bort MDS',
        body: 'MDS:en lämnar noden {node}. På ett deployat kluster stoppas daemonen och dess tillstånd tas bort; API:et avvisar den sista MDS:en så länge ett filsystem behöver den.',
        error: 'Borttagningen av MDS:en avvisades'
      },
      split: {
        title: 'Åtskilda MON/MGR',
        label: 'Tillåt MON och MGR på åtskilda noder',
        hint: 'Av (standard) = den ratificerade standarden: en MGR kör samplacerad med varje MON, ett enda medlemskap. På = MGR-medlemskapet blir sitt eget, hanterat med åtgärderna Lägg till/Ta bort MGR i fliken Hanteringsnoder.',
        enable: 'Aktivera',
        disable: 'Inaktivera',
        enableBody: 'MGR-medlemskapet blir oberoende av MON, initierat från den nuvarande samplaceringen. Åtgärderna Lägg till/Ta bort MGR aktiveras i fliken Hanteringsnoder. Detta luckrar upp plattformens standard — behåll det bara om du vet varför du behöver det.',
        disableBody: 'Återgång till standardsamplaceringen: en MGR med varje MON, ett enda medlemskap. Lagligt bara om MGR-medlemskapet redan sammanfaller med MON — rikta in det först med Lägg till/Ta bort MGR, annars avvisar API:et.',
        error: 'Ändringen avvisades'
      },
      rawEditor: {
        title: 'Rå CRUSH-editor',
        label: 'Visa den råa crushmap-editorn i fliken CRUSH',
        hint: 'Av (standard) = den guidade regelytan är standardverktyget. På = fliken CRUSH visar även den dekompilerade crushmapen som redigerbar text. Att spara kräver alltid sudo, klustrets namn som bekräftelse, och går genom crushtools compile + test INNAN det når klustret.'
      },
      osdFlags: {
        section: 'Globala OSD-flaggor',
        title: 'Override av OSD-flaggor',
        notObserved: 'ännu inte observerade',
        standardFlowsHint: 'Plattformens standardflöden hanterar de här flaggorna själva i de normala fallen (underhåll av en nod sätter en riktad noout, diskbyte går genom OSD-livscykeln). Den här sektionen är den manuella overriden för operatören som vet vad hen gör.',
        notDeployedGuard: 'OSD-flaggorna finns bara på ett deployat kluster',
        set: 'Sätt flagga',
        unset: 'Ta bort flagga',
        setBody: 'Den globala flaggan {flag} kommer att SÄTTAS på osdmapen. Den ligger kvar tills den uttryckligen tas bort — en bortglömd flagga degraderar klustrets självläkning.',
        unsetBody: 'Den globala flaggan {flag} kommer att TAS BORT från osdmapen.',
        error: 'Flaggändringen avvisades',
        flag: {
          noout: 'Ingen OSD markeras out ur datadistributionen — ingen ombalansering när en daemon förloras',
          norebalance: 'Ombalanseringen av data är pausad',
          nobackfill: 'Backfillen är pausad',
          norecover: 'Recoveryn är pausad',
          pause: 'ALL klient-I/O är pausad (läsningar och skrivningar)',
          noin: 'OSD:er som startar markeras inte in automatiskt',
          nodown: 'Onåbara OSD:er markeras inte down — maskerar verkliga fel'
        }
      },
      pools: {
        section: 'Pooler',
        create: 'Skapa pool',
        createGuard: 'Pooler finns bara på ett deployat kluster',
        notObserved: 'Ingen observation av poolerna — MON:ens sweep rapporterar hit',
        empty: 'Ingen pool på klustret',
        colName: 'Namn',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Applikation',
        colRule: 'CRUSH-regel',
        colUsage: 'Användning',
        observedAtLabel: 'Observerad den',
        objects: '{n} objekt',
        inUseBy: 'används av {name}',
        internalGuard: 'Intern Ceph-pool — plattformen raderar den aldrig',
        delete: 'Radera pool',
        deleteGuard: 'Konsumeras av storagen {name} — radera storagen först',
        hint: 'Endast replikerade pooler (erasure coding utanför scope i v1). Replikeringen bor i Ceph: den här tabellen är sanningen som MON:ens sweep observerat.',
        createTitle: 'Skapa pool',
        createHint: 'Poolen föds på klustret med den begärda replikeringen och applikationen rbd aktiverad — jobbet görs av en task på en MON-nod. Slå på "Föreslå som storage" för att konsumera den direkt i samma gest.',
        name: 'Poolens namn',
        nameHint: 'DNS-safe (gemener, siffror, bindestreck).',
        size: 'Repliker (size)',
        sizeHint: 'Kopior av varje objekt. Standard 3.',
        minSize: 'Minsta antal repliker (min_size)',
        minSizeHint: 'Minsta antal kopior för att servera I/O — följer size − 1 tills du ändrar det.',
        createError: 'Skapandet av poolen avvisades',
        deleteTitle: 'Radera pool',
        deleteBody: 'Poolen {pool} och VARJE objekt i den förstörs oåterkalleligt. Skriv poolens namn för att bekräfta.',
        confirmLabel: 'Poolens namn',
        confirmHint: 'Skriv poolens namn för att bekräfta',
        deleteError: 'Raderingen av poolen avvisades',
        detailTitle: 'Pooldetaljer',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktiv',
        autoscalerOff: 'Inte aktiv',
        autoscalerWarn: 'Avisering',
        pgNumLabel: 'Antal PG',
        pgNumCaption: 'Observerat: autoscalern kan ändra det på egen hand — det här fältet skriver en önskan.',
        storage: 'Associerad TVirt-storage',
        addAsStorage: 'Lägg till som TVirt-storage',
        ruleSudoHint: 'Byte av CRUSH-regel kräver operatörens lösenord.',
        updateError: 'Ändringen av poolen avvisades',
        updated: 'Pooländringen startad — observationen uppdaterar sig själv'
      },
      crush: {
        section: 'CRUSH-regler',
        notObserved: 'Ingen CRUSH-observation ännu — MON:ens sweep rapporterar hit',
        empty: 'Ingen regel observerad på klustret',
        hint: 'En regel avgör VAR kopiorna av varje objekt hamnar — dess feldomän är enheten som kan fallera utan att data går förlorade. Poolerna pekar på en regel; den inbyggda replicated_rule (en replik per server) är standarden från födseln.',
        create: 'Skapa regel',
        createGuard: 'CRUSH-regler finns bara på ett deployat kluster',
        createTitle: 'Skapa CRUSH-regel',
        createHint: 'En regel = ett val av feldomän. Regeln föds replikerad på standard-rooten — jobbet görs av en task på en MON-nod; associera poolerna från fliken Pooler efteråt.',
        createError: 'Skapandet av regeln avvisades',
        name: 'Regelns namn',
        nameHint: 'DNS-safe (gemener, siffror, bindestreck).',
        domain: 'Feldomän',
        domainChoice: {
          osd: 'Varje replik på en egen OSD',
          host: 'Varje replik på en egen server',
          rack: 'Varje replik i ett eget rack'
        },
        domainCustom: 'Anpassad (handskrivna steg)',
        domainOther: 'Varje replik i en egen {type}',
        rackGuardHint: 'Ingen rack-bucket finns i den observerade hierarkin: regeln kan skapas ändå, men ingen pool kan peka på den förrän ett rack har deklarerats i medlemsservrarnas placering (nodens inställningar) — omjusteringstasken bygger bucketen och associeringen öppnar sig själv.',
        treeTitle: 'Observerad hierarki',
        treeNotObserved: 'Ingen observation av hierarkin — MON:ens sweep rapporterar hit',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH-mapen som klustret ser den: root → deklarerade nivåer → server (host) → OSD. Topologin följer varje servers deklarerade placering (nodens inställningar) — ett positionsbyte justerar om den via task.',
        unplacedWarning: 'Medlemmar utan deklarerad position: {nodes} — deras hostar ligger kvar direkt under rooten, utanför den deklarerade topologin. Deklarera positionen i nodens inställningar (en varning, aldrig en spärr).',
        colName: 'Namn',
        colDomain: 'Feldomän',
        colPools: 'Pooler',
        builtinChip: 'builtin',
        builtinGuard: 'Klustrets standardregel — plattformen raderar den aldrig',
        detailAction: 'Regeldetalj',
        detailType: 'Typ',
        backToRules: 'Regler',
        ruleNotObserved: 'Den observerade regellistan nämner inte den här regeln',
        noPools: 'Ingen pool rider på den här regeln',
        delete: 'Radera regel',
        deleteTitle: 'Radera CRUSH-regel',
        deleteBody: 'Regeln {rule} tas bort ur klustrets crushmap. Ingen pool får rida på den. Skriv regelns namn för att bekräfta.',
        deleteGuard: 'Poolen {name} rider på den — peka om poolen först',
        confirmLabel: 'Regelns namn',
        confirmHint: 'Skriv regelns namn för att bekräfta',
        deleteError: 'Raderingen av regeln avvisades',
        changeRule: 'Byt CRUSH-regel',
        changeRuleTitle: 'Byt CRUSH-regel',
        changeRuleHint: 'Poolen börjar placera sina objekt enligt den valda regeln — Ceph flyttar befintliga data för att rätta sig (på en full pool följer en ombalansering).',
        changeRuleError: 'Regelbytet avvisades',
        rule: 'CRUSH-regel',
        rawTitle: 'Rå crushmap (dekompilerad)',
        rawWarning: 'FARA: den här texten är klustrets HELA placeringspolicy. En felaktig map kan förstöra placeringen för alla pooler på en gång. Att spara kompilerar och provkör mapen med crushtool INNAN den injiceras — men en giltig map kan ändå vara en dålig idé.',
        rawReload: 'Läs om',
        rawLoading: 'Query pågår — en read-only-task dekompilerar crushmapen…',
        rawSave: 'Spara crushmap',
        rawSaveTitle: 'Injicera crushmap',
        rawSaveBody: 'Den ändrade texten ersätter HELA klustrets crushmap efter crushtools compile + test. Skriv klustrets namn för att bekräfta.',
        rawConfirmLabel: 'Klustrets namn',
        rawConfirmHint: 'Skriv {name} för att bekräfta',
        rawError: 'Operationen på crushmapen misslyckades',
        rawHint: 'Texten är formen crushtool -d. Kompilerings- och testfel kommer tillbaka ord för ord från crushtool — mapen når inte klustret om någon av de två grindarna fallerar.'
      },
      objects: {
        poolsSection: 'Objektutforskare',
        poolsHint: 'Välj en pool för att lista dess RBD-avbilder. Varje djup läsning kör som read-only-task på en MON-nod — den blockerar inte (och blockeras inte av) de verkliga operationerna.',
        deployedGuard: 'Objektqueries svarar bara på ett deployat kluster',
        browse: 'Bläddra bland objekten',
        detailAction: 'Avbilddetalj',
        backToPools: 'Pooler',
        backToImages: 'Avbilder',
        refresh: 'Uppdatera',
        loading: 'Query pågår — en read-only-task frågar klustret…',
        error: 'Queryn misslyckades',
        retry: 'Försök igen',
        notRbd: 'Pool med application "{app}" — den innehåller inga RBD-avbilder, inget att utforska här',
        noImages: 'Ingen RBD-avbild i den här poolen',
        colImage: 'Avbild',
        colSize: 'Storlek',
        colObjects: 'Objekt',
        colSnapshots: 'Snapshots',
        imagesHint: 'Diskarna på en konsumerande rbd-storage är avbilder med sitt disk-id som namn. Objekträkningen är det provisionerade (storlek / objektstorlek) — den verkliga användningen bor i avbilddetaljen.',
        infoTitle: 'Avbild',
        infoSize: 'Virtuell storlek',
        infoObjects: 'Objekt (provisionerade)',
        infoObjectSize: 'Objektstorlek',
        infoPrefix: 'Objektprefix',
        infoFormat: 'Format',
        infoFeatures: 'Features',
        usageTitle: 'Verklig användning (rbd du)',
        usageOf: 'av {provisioned} GiB provisionerade',
        usageHint: 'Thin av naturen: bara skrivna objekt upptar byte.',
        watchersTitle: 'Watchers',
        noWatchers: 'Ingen watcher — ingen har den här avbilden öppen just nu',
        snapshotsTitle: 'RBD-snapshots',
        noSnapshots: 'Ingen RBD-snapshot på den här avbilden',
        colSnapshot: 'Snapshot',
        colProtected: 'Skyddad',
        colTimestamp: 'Skapad',
        protected: 'skyddad',
        mappingTitle: 'Fysisk mappning (OSD-mängd)',
        mappingSampled: 'Ett urval av {sampled} objekt av {total} — en ärlig sammanfattning: för stora avbilder konvergerar mängden mot ALLA poolens OSD:er (CRUSH sprider objekten över hela poolen).',
        mappingComplete: 'Alla objekt mappade ({total} av {total}).',
        objectQueryTitle: 'Mappa ett enskilt objekt',
        objectName: 'Objektnamn',
        objectHint: 'RADOS-objektnamn är <prefix>.<16-hex-index> — ceph osd map svarar med PG och OSD-tripplar.',
        mapObject: 'Mappa',
        primary: 'primär: osd.{osd}'
      },
      registerDevice: {
        title: 'Registrera OSD-enhet',
        hint: 'På ett levande kluster PREPARERAR registreringen även enheten: den blir en BlueStore-OSD med en automatisk nod-affin task (aldrig tom, ratificerat 2026-07-24). En enhet tillhör högst ett Ceph-kluster i hela flottan.',
        disk: 'Datadisk',
        diskHint: 'Nodens deklarerade datadiskar — namn och serienummer',
        noDeclared: 'Ingen deklarerad datadisk på den här noden — märk upp dem först i nodens lokala inställningar',
        serialHint: 'Enhetens serienummer — identitetsnålen',
        encrypted: 'Kryptera den här OSD:n (dmcrypt)',
        encryptedHint: 'Valet per OSD (klustrets läge är "val per OSD"): det fryses på den här disken vid registreringen — ett senare lägesbyte skriver aldrig om det; det gör radåtgärden kryptera/dekryptera.',
        error: 'Registreringen avvisades'
      },
      unregisterDevice: {
        title: 'Avregistrera enhet',
        body: 'Endast registret: {name} slutar vara en OSD-kandidat för det här klustret. Dess byte rörs inte.',
        error: 'Avregistreringen avvisades'
      },
      deploy: {
        action: 'Försök deploy igen',
        title: 'Försök bootstrappen igen',
        body: 'Födelsebootstrappen startar om från den aktuella konfigurationen: MON:erna startar, varje registrerad enhet prepareras och aktiveras som BlueStore-OSD. Operationen kör som macrotask — fasen uppdaterar sig själv.',
        started: 'Bootstrap startad — den fortsätter som macrotask; fasen uppdaterar sig själv',
        error: 'Bootstrappen avvisades'
      },
      propose: {
        action: 'Föreslå som storage',
        title: 'Föreslå som storage',
        hintPool: 'Den befintliga poolen {name} blir en TVirt-storage: en cephx-identitet begränsad till poolen hamnar i keystoren och ceph-rbd-storagen föds färdig. Förslaget konsumerar poolen — det skapar aldrig någon.',
        hintFs: 'Det befintliga filsystemet {name} blir en TVirt-storage: en cephx-identitet begränsad till filsystemet hamnar i keystoren och cephfs-storagen föds färdig och monterad. Förslaget konsumerar filsystemet — det skapar aldrig något.',
        name: 'Storagens namn',
        nameHint: 'DNS-1123, unikt inom scopet — cephx-identiteten tar sitt namn från den.',
        path: 'Path inuti filsystemet',
        pathHint: 'Absolut path inuti filsystemet som storagen monterar — / om du är osäker.',
        alsoPropose: 'Föreslå direkt som storage',
        alsoProposePoolHint: 'Efter skapandet föreslår samma gest den nyfödda poolen som ceph-rbd-storage — två explicita anrop, en enda dialog.',
        alsoProposeFsHint: 'Efter skapandet föreslår samma gest det nyfödda filsystemet som cephfs-storage — två explicita anrop, en enda dialog.',
        guard: 'Föreslå som storage — endast på ett friskt kluster',
        started: 'Förslaget accepterat — storagen materialiseras; du hittar den under Storage',
        submit: 'Skapa storage',
        error: 'Förslaget avvisades'
      },
      fs: {
        section: 'Filsystem',
        create: 'Skapa filsystem',
        createGuard: 'Filsystem finns bara på ett deployat kluster',
        mdsFirstGuard: 'Lägg till en MDS först — ett filsystem utan metadata server föds oanvändbart',
        notObserved: 'Ingen observation av filsystemen — MON:ens sweep rapporterar hit',
        empty: 'Inget filsystem på klustret',
        colName: 'Namn',
        colPools: 'Pooler',
        colMds: 'MDS',
        noActiveMds: 'ingen aktiv MDS',
        delete: 'Ta bort filsystem',
        deleteGuard: 'Konsumeras av storagen {name} — radera storagen först',
        hint: 'Ett filsystem äger sina data- och metadatapooler (cephfs.<namn>.data / .meta): de föds med det och dör med det — removeFs, aldrig en manuell poolradering. Den här tabellen är sanningen som MON:ens sweep observerat.',
        createTitle: 'Skapa filsystem',
        createHint: 'Filsystemet föds på klustret med sina två pooler (application cephfs) och serveras av de deklarerade MDS:erna — jobbet görs av en task på en MON-nod. Slå på "Föreslå som storage" för att konsumera det direkt i samma gest.',
        name: 'Filsystemets namn',
        nameHint: 'DNS-safe (gemener, siffror, bindestreck).',
        sizeHint: 'Repliker för BÅDA de nyfödda poolerna. Standard 3.',
        createError: 'Skapandet av filsystemet avvisades',
        deleteTitle: 'Ta bort filsystem',
        deleteBody: 'Filsystemet {fs} och VARJE fil i det förstörs oåterkalleligt — dess data- och metadatapooler dör med det. Skriv filsystemets namn för att bekräfta.',
        confirmLabel: 'Filsystemets namn',
        confirmHint: 'Skriv filsystemets namn för att bekräfta',
        deleteError: 'Borttagningen av filsystemet avvisades'
      },
      destroy: {
        action: 'Förstör',
        retryAction: 'Försök raderingen igen',
        retryGuard: 'Förstörelsen kör just nu — retryn gäller en misslyckad förstörelse (leaset avvisar annars)',
        title: 'Förstör klustret',
        body: 'Den deployade fabricen monteras ned: varje daemon i det här klustret stoppas, dess systemtillstånd och nycklarna i keystoren släpps. När förstörelsen lyckats tas klustret bort automatiskt.',
        confirmLabel: 'Klustrets namn',
        confirmHint: 'Skriv klustrets namn för att bekräfta',
        wipe: 'Rensa de registrerade enheterna',
        wipeHint: 'Ikryssad: signaturerna på varje registrerad enhet raderas — datan ovanpå är förstörd. Inte ikryssad: bytena förblir intakta och enheterna blir åter registrerade.',
        guard: 'Förstör — inget är deployat',
        started: 'Förstörelsen startad — den fortsätter som macrotask; fasen uppdaterar sig själv',
        error: 'Förstörelsen avvisades'
      },
      delete: {
        guard: 'Radera — endast en icke deployad konfiguration (förstör först)',
        title: 'Radera {name}?',
        body: 'Konfigurationen och dess enhetsregister tas bort. Lagligt bara så länge inget är deployat.',
        error: 'Raderingen avvisades'
      }
    }
  }
}
